/********************** PRODUCT PAGE JS START  **********************/
if(window.location.href.includes('products')){
  const readMoreBtn = document.querySelector('.read-more-btn');
  const main_description = document.querySelector('.description');
  const description = document.querySelector('.description p');

  if(readMoreBtn){
    readMoreBtn.addEventListener('click', () => {
      main_description.classList.toggle('expanded');
      readMoreBtn.textContent = main_description.classList.contains('expanded')
        ? 'Read less'
        : 'Read more';
    });
  }
}